export default __webpack_public_path__ + "static/media/engage-tablet2_V2.9854f517.png";